import React, { useEffect } from "react"
import AsyncSelect from 'react-select/async';
import { debounce } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "store";
import { UserBrand } from "types/users";
import { fetchUserBrands as fetchUserBrandThunk } from "slices/users/brands/thunk";
import { fetchUserBrands } from "services/api/users";
import Select from 'react-select'
interface Option {
    value: string | number,
    label: string
}

interface BrandSelectionProps {
    value: Option | null,
    onChange: (brand: Option     | null) => void
    [key: string]: any
}

const BrandSelection: React.FC<BrandSelectionProps> = ({ value, onChange, ...rest }) => {

    const dispatch:AppDispatch = useDispatch();
    const selectedAgencyId = useSelector((state: RootState) => state.auth.selectedAgencyId);
    const userBrands = useSelector((state: RootState) => state.userBrands.items);

    useEffect(() => {
        dispatch(fetchUserBrandThunk(true));
    }, [])

    const _loadBrandsSuggestion = (q: string, callback: any) => {
        if (!q) return callback([]);

        fetchUserBrands(selectedAgencyId!, {q})
            .then(resp => callback(resp.map((item: UserBrand) => ({ value: item.id, label: item.name })))).catch(() => callback([]))
    };

    const loadBrandsSuggestions = debounce(_loadBrandsSuggestion, 200);

    const handleChange = (selected: any) => {
        onChange(selected)
    }

    const customStyles = {
        option: (provided: any, state: any) => ({
          ...provided,
          backgroundColor: state.isSelected
            ? '#0069AD'
            : state.isFocused
            ? '#BBD8ED' // optional: on hover/focus
            : 'white',
          color: state.isSelected ? 'white' : 'black', // adjust text color
        }),
      };

    return (
        <Select {...rest}  isClearable={true} styles={customStyles} options={(userBrands ?? []).map((ub) => ({label: ub.name, value: ub.id}))} classNamePrefix={'brand-select'} placeholder='Select Brand' noOptionsMessage={() => "No brands!"} menuPlacement='top' value={value} onChange={handleChange} />
    )
}

export default BrandSelection